export default {
  ABOUT_ME: 'ABOUT_ME',
  MY_CANCER: 'MY_CANCER',
  TREATMENT: 'TREATMENT',
  MY_HEALTH: 'MY_HEALTH'
};
